// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"b6ac1a03","152":"5a138b9b","171":"cc7ad1a8","294":"598a2107","453":"eee9a4d2","564":"de210e7c","626":"3ea47f8d","743":"a651aa47","799":"9b7c9e45"}[chunkId] + ".chunk.js";
};